import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const REVENUE_DEFAULT_CURRENCY_CODE_TOKEN = new InjectionToken<Observable<string>>(
  'revenue default currency code',
);
